import { render, staticRenderFns } from "./HostelAssignmentCard.vue?vue&type=template&id=a1ffb0c6"
import script from "./HostelAssignmentCard.vue?vue&type=script&lang=js"
export * from "./HostelAssignmentCard.vue?vue&type=script&lang=js"
import style0 from "./HostelAssignmentCard.vue?vue&type=style&index=0&id=a1ffb0c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports